import React from 'react';
import { CircleLoading } from 'react-loadingg';


const LoadingAnimation = () => {
    return (
        <div style={{"width": "100%", "marginTop": "15%", "backgroundColor": "black", "transform": "scale(3)"}} id="pageLoading">
            <CircleLoading color="#90be4e" />
        </div>
    );
};


export default LoadingAnimation;